import { isPatron, scrollToTop } from '../util/helpers'
import { useDispatch, useSelector } from 'react-redux'
//import Ad from './Ad'
//import AlertDismissible from './AlertDismissable'
import AlternateArtModal from './AlternateArtModal'
import Clipboard from './Clipboard'
import ErrorBoundary from './ErrorBoundary'
import Footer from './Footer'
import GoogleAnalytics from './GoogleAnalytics'
import { Helmet } from 'react-helmet'
import Leaderboard from './Leaderboard'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import ScrollToTopButton from './ScrollToTopButton'
import classNames from 'classnames'
import { fetchMisc } from '../store/misc'
import styles from '../styles/Layout.module.scss'
import useDarkMode from 'use-dark-mode'
import { useEffect } from 'react'

const Layout = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.firebase.profile)
  const location = useSelector((state) => state.pagedata.location)
  const prevLocation = useSelector((state) => state.pagedata.prevLocation)

  useEffect(() => {
    dispatch(fetchMisc())
    scrollToTop()
  }, [])

  useEffect(() => {
    if (location !== prevLocation && !location.state?.noTop) {
      scrollToTop()
    }
  }, [location, prevLocation])

  return (
    <div
      className={classNames(styles.containerOuter, {
        [styles.darkMode]: darkMode.value,
      })}
    >
      <div className={classNames(styles.container, styles.background)}>
        <ErrorBoundary>
          <AlternateArtModal />
        </ErrorBoundary>
        <ErrorBoundary>
          <Clipboard />
        </ErrorBoundary>
        <GoogleAnalytics />
        <ScrollToTopButton />
        <Navbar />
        <div className={styles.containerInner}>
          <ErrorBoundary>
            {/*<AlertDismissible />*/}
            {isPatron(profile) || (
              <>
                <Leaderboard />
                <Helmet>
                  <script
                    type='text/javascript'
                    async='async'
                    data-noptimize='1'
                    data-cfasync='false'
                    src='//scripts.mediavine.com/tags/edhrec.js'
                  ></script>
                </Helmet>
              </>
            )}
            <div className={classNames(styles.background)}>
              <div className={styles.layout}>
                <div className={styles.left}>
                  <Outlet />
                </div>
                {/* <Right /> */}
              </div>
            </div>
          </ErrorBoundary>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
